import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import SlotGameModel from 'Engine/slots/model/SlotGameModel';
import eBigWinDefaultCoefs from '../enums/eBigWinDefaultCoefs';
import eBigWinTypes from '../enums/eBigWinTypes';
import ServerManager from '../server/ServerManager';
import eGameMode from '../enums/eGameMode';
import eSymbolIndex from '../symbols/eSymbolIndex';

export default new class GameModel extends SlotGameModel {
  constructor() {
    super();
    this._respins = 0;
    this._bonusGameTotalWin = 0;
    this._lastWin = 0;
    this._jackpotsCount = 0;
    this._bonusGameAvailableReels = [];

    GlobalDispatcher.addOnce('model:getServerData', () => {
      this._winRankCoef = {
        [eBigWinTypes.EBWT_WIN]: eBigWinDefaultCoefs.EBWC_WIN,
        [eBigWinTypes.EBWT_BIG_WIN]: OPWrapperService.config.minWinRankCoef ? OPWrapperService.config.minWinRankCoef : eBigWinDefaultCoefs.EBWC_BIG_WIN,
        [eBigWinTypes.EBWT_MEGA_WIN]: eBigWinDefaultCoefs.EBWC_MEGA_WIN
      };
    }, this);
  }

  init() {
    super.init();
    ServerManager.onInit();
  }

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add('ui:setMinBet', this.onMinBetPressed, this);
  }

  setNewData(data) {
    this._lastWin = this.totalWin || this._lastWin;
    this._bonusGame = data.bonusGame;

    super.setNewData(data);
    this._jackpotCoeffs = data.jackpotCoeffs || this._jackpotCoeffs;
    this._lastJackpotsCount = this._jackpotsCount;
    this._jackpotsCount = data.jackpotsCount;
    this._spinCoeffs = data.spin?.coeffs;
    this._gameMode = this.isFreeSpinsMode ? eGameMode.EGM_BONUS : eGameMode.EGM_REGULAR;
    this._bonusGameAvailableReels = data.bonusGame.available_reels || this._bonusGameAvailableReels;
    this.updateAvailableBonusLabels();

    GlobalDispatcher.dispatch('model:getServerData', data.action);
  }


  getReels(mode) {
    switch (mode) {
      case eGameMode.EGM_REGULAR:
        return this.reels;
      case eGameMode.EGM_BONUS:
        return this.bonusReels;
      default:
        throw new Error(`Unhandled mode ${mode}`);
    }
  }

  changeBet(index) {
    if (index >= this._betPossible.length) index = this._betPossible.length - 1;
    if (index < 0) index = 0;

    this.betIndex = index;
  }

  onMinBetPressed() {
    this.changeBet(0);
  }

  updateAvailableBonusLabels() {
    this._availableBonusLabels = [
      ...this.bonusGameWinAmounts.slice(0, this.bonusGameWinAmounts.length - 3),
      'MINI', 'MAJOR', 'GRAND'
    ];
  }

  getBonusLabel(id) {
    const labels = this.availableBonusWinLabels;
    const index = this.availableBonusSymbolIds.indexOf(id);
    return labels[index];
  }

  getBonusAmount(id) {
    const index = this.availableBonusSymbolIds.indexOf(id);
    return this.bonusGameWinAmounts[index];
  }

  set lastJackpotsCount(value) {
    this._lastJackpotsCount = value;
  }

  get hasJackpot() {
    return this._jackpotsCount > this._lastJackpotsCount;
  }

  get availableBonusWinLabels() {
    return this._availableBonusLabels;
  }

  get availableBonusSymbolIds() {
    return this._bonusGame.symbols_values;
  }

  get bonusGameWinAmounts() {
    return this._bonusGame.symbols_values_money;
  }

  get bonusMultiplier() {
    return this._bonusGame.multiplier;
  }

  get gameMode() {
    return this._gameMode;
  }

  get reels() {
    let reels = [];

    super.reels.forEach((originalReel, reelIndex) => {
      const reel = [];

      originalReel.forEach((symbolId, symbolIndex) => {
        let id = symbolId;
        if (id === eSymbolIndex.ESI_BONUS) {
          const coeff = this._spinCoeffs[reelIndex][symbolIndex];
          if (this.jackpotCoeffs.includes(coeff)) {
            id = [eSymbolIndex.ESI_BONUS_MINI, eSymbolIndex.ESI_BONUS_MAJOR, eSymbolIndex.ESI_BONUS_GRAND][this.jackpotCoeffs.indexOf(coeff)];
          }
        }
        reel.push(id);
      });

      reels.push(reel);
    });

    return reels;
  }

  get bonusReels() {
    const reels = [];
    this._bonusGame.field_coeffs.forEach(reel => reel.forEach(symbol => reels.push([symbol])));
    return reels;
  }

  get paytableInfo() {
    return this._paytableInfo;
  }

  get freespins() {
    return this._bonusGame.respins_count;
  }

  get freespinsTotalWin() {
    return this._bonusGame.bonus_total_win;
  }

  get isFreeSpinsMode() {
    return this._bonusGame.is_bonus;
  }

  get bonusField() {
    return this._bonusGame.field;
  }

  get freespinsEnabled() {
    return this._bonusGameEnabled;
  }

  set freespinsEnabled(value) {
    this._bonusGameEnabled = value;
    this._isSpinWithoutBalanceCheck = value;
  }

  get freespinsTriggered() {
    return this._bonusGame.bonus_triggered;
  }

  get jackpotList() {
    return this._jackpotCoeffs.map(coef => this.bet * coef);
  }

  get jackpotCoeffs() {
    return this._jackpotCoeffs;
  }

  get isBonusGameMode() {
    return this.isFreeSpinsMode;
  }

  get lastWin() {
    return this._lastWin;
  }

  get totalWin() {
    let win = this._bonusGame?.field?.total_win_multiplied || 0;
    if (this._winnings) {
      win += this.winnings.totalWin;
    }
    return win;
  }

  get freespinsAvalibleReels() {
    return this.bonusGameAvailableReels;
  }

  get bonusGameAvailableReels() {
    return this._bonusGameAvailableReels
  }

  get winRankCoef() {
    return this._winRankCoef;
  }
}
